export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.9.10-0849.26",
  commitId: "5a0da361027fccc91a437927fa79a9f84fb85842",
  commitTime: "2026-09-10T08:49:26.000Z",
});
